import { Dialog, DialogContent } from "@mui/material";
import { ReactNode, useState } from "react";

import { GetAudienceContactFieldsQuery } from "~frontend/__generated__/graphql";
import { useFeatureFlag } from "~frontend/providers/LoggedInUserProvider/context";

import { AddOrEditField } from "./AddOrEditField";
import { ViewFields } from "./ViewFields";

export const ManageCustomFieldsDialog = ({
  opnId,
  audienceId,
  onClose,
  existingFields = [],
}: {
  opnId: string;
  audienceId: string;
  onClose: () => void;
  existingFields?: GetAudienceContactFieldsQuery["getAudienceContactFields"];
}): ReactNode => {
  const [editingField, setEditingField] = useState<
    | GetAudienceContactFieldsQuery["getAudienceContactFields"][number]
    | "NEW"
    | null
  >(null);
  const customFieldsAllowed = useFeatureFlag("audienceCustomFields");

  if (!customFieldsAllowed) {
    return null;
  }

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        {editingField !== null ? (
          <AddOrEditField
            audienceId={audienceId}
            field={
              editingField === "NEW"
                ? "NEW"
                : {
                    id: editingField.id,
                    name: editingField.name,
                    type: editingField.type,
                    typeParameters: editingField.typeParameters,
                  }
            }
            onClose={() => setEditingField(null)}
            existingFields={existingFields}
          />
        ) : (
          <ViewFields
            opnId={opnId}
            setEditingField={setEditingField}
            onCancel={onClose}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
